import React from 'react';
import Icon from '../../common/Icons';
import { getPhysicianHubIcon } from '../physicianHubIcons';

export default function PhysicianHubCard({ def, badgeLabel, onClick, onPrescriptionLink }) {
  const iconName = getPhysicianHubIcon(def);
  const isReady = def.badge === 'ready';

  return (
    <article
      className={`ph-hub-card ${isReady ? 'ph-hub-card--ready' : 'ph-hub-card--soon'}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          onClick();
        }
      }}
    >
      <div className="ph-hub-card__icon-wrap" aria-hidden>
        <Icon name={iconName} size={22} />
      </div>
      <div className="ph-hub-card__body">
        <div className="ph-hub-card__top">
          <h3 className="ph-hub-card__title mb-0">{def.title}</h3>
          <span className={`ph-hub-badge ${isReady ? 'ph-hub-badge--ready' : 'ph-hub-badge--soon'}`}>
            {badgeLabel}
          </span>
        </div>
        <p className="ph-hub-card__desc mb-0">{def.subtitle}</p>
        {def.kind === 'route' && def.routeKey === 'PRESCRIPTIONS' && onPrescriptionLink && (
          <button
            type="button"
            className="ph-hub-card__link btn btn-link btn-sm p-0 mt-2"
            onClick={(e) => {
              e.stopPropagation();
              onPrescriptionLink();
            }}
          >
            Rédiger une ordonnance
          </button>
        )}
      </div>
      <span className="ph-hub-card__chevron" aria-hidden>
        →
      </span>
    </article>
  );
}
